module.exports = __webpack_public_path__ + "static/booking_engine_home-ba4d2663d3db53a01122d5ce82709fc7.png";